module.exports = __webpack_public_path__ + "static/media/environment-gas.f21940af.svg";